import React, { Component } from 'react';
import classnames from 'classnames';

// Tabs
import GlobalEntityTab from './Tabs/GlobalEntityTab';
import EntityTab from './Tabs/EntityTab';
import ModuleTab from './Tabs/ModuleTab';
import AgentTab from './Tabs/AgentTab';

class ListTabs extends Component {

  static defaultProps = {
    setTabType : () => {
      
    },
    disabledTabTypes : [],
    isForInstance : false
  }

  state = {
    activeTabType : null,
  }

  tabs = [GlobalEntityTab, EntityTab, ModuleTab, AgentTab];

  handleTabClicked = (tabType) => {
    const { setTabType } = this.props;
    this.setState({
      activeTabType : tabType,
    })
    setTabType(tabType);
  }

  render() {
    
    const { handleTabClicked } = this;
    const { activeTabType } = this.state;
    const { 
      showTabs
    } = this.props

    // Show tabs
    const {
      GLOBAL_ENTITY,
      TOPIC_ENTITY,
      MODULE,
      AGENT,
    } = showTabs

    const renderTabs = (tabs = this.tabs) => {
      return tabs.map((tab, i) => {
        switch(i){
          case 0: // Global entity
          if (!!GLOBAL_ENTITY) {
            return (
              <GlobalEntityTab activeTabType={activeTabType}
                tabClicked={handleTabClicked}
                isLastTab={tabs.length-1 === i} />
            )
          } 
          break;

          case 1: // Entity
          if (!!TOPIC_ENTITY) {
            return (
              <EntityTab activeTabType={activeTabType}
                tabClicked={handleTabClicked}
                isLastTab={tabs.length-1 === i} />
            )
          }
          break;
          
          case 2: // module
          if (!!MODULE) {
            return (
              <ModuleTab activeTabType={activeTabType}
                tabClicked={handleTabClicked}
                isLastTab={tabs.length-1  === i} />
            )
          }
          break;
          
          case 3: // agent
          if (!!AGENT) {
            return (
              <AgentTab activeTabType={activeTabType}
                tabClicked={handleTabClicked}
                isLastTab={tabs.length-1 === i} />
            )
          }
          break;

          default: // no select

        }
      })                                                                                                                                                                                                                                                                                                                               
    }

    return (
      <React.Fragment>
        {renderTabs()}
      </React.Fragment>
    );
  }
}

export default ListTabs;